<script lang="ts" setup>
import { ref, watch } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faThumbsDown, faThumbsUp } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps<{
  contentId: string | number;
  value?: 1 | 0 | null;
  color?: string;
}>();

const emit = defineEmits<{
  (e: 'rate', payload: { contentId: string | number; value: 1 | 0 | null }): void;
}>();

const selectedValue = ref<1 | 0 | null>(props.value ?? null);

watch(
  () => props.value,
  (val) => {
    selectedValue.value = val ?? null;
  },
);

const handleRating = (value: 1 | 0): void => {
  selectedValue.value = value;
  emit('rate', { contentId: props.contentId, value });
};
</script>
<template>
  <div class="d-flex ga-1">
    <v-btn
      icon
      :variant="selectedValue === 1 ? 'text' : 'plain'"
      :color="props.color ?? 'white'"
      :aria-label="'Rate positively'"
      :aria-pressed="selectedValue === 1"
      @click="handleRating(1)"
    >
      <FontAwesomeIcon :icon="faThumbsUp" size="xl" />
    </v-btn>
    <v-btn
      icon
      :variant="selectedValue === 0 ? 'text' : 'plain'"
      :color="props.color ?? 'white'"
      :aria-label="'Rate negatively'"
      :aria-pressed="selectedValue === 0"
      @click="handleRating(0)"
    >
      <FontAwesomeIcon :icon="faThumbsDown" size="xl" />
    </v-btn>
  </div>
</template>
